import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ActionSheetController, ModalController } from '@ionic/angular';
import { ViewApplicationDetailModel } from 'src/app/model/ViewApplicationDetailModel';
import { ViewApplicationService } from 'src/app/services/view-application.service';
import { ViewPdfComponent } from '../../view-pdf/view-pdf.component';
import { AuditTrailService } from 'src/app/audit-trail/audit-trail.service';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ViewProfileDocumentComponent } from 'src/app/audit-trail/profile-details/view-profile-document/view-profile-document.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UploadFileModalComponent } from '../../upload-file-modal/upload-file-modal.component';

@Component({
  selector: 'app-secure-view-application-dtl',
  templateUrl: './agreement-indx-upld-dtl.component.html',
  styleUrls: ['./agreement-indx-upld-dtl.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AgreementIndxUpldDtlComponent implements OnInit {
  data: ViewApplicationDetailModel;
  applicationId: number;
  selectedFile: File;
  submitDisabled: boolean;
  isLoading: boolean = false;
  manualRejectedQuestions: any[] = [];
	documents: any[] = [];
	verifiedStatus: any[] = [];
  documentName: string = "";
  profileDetails: any[] = [];
  areQuestionsNotAnswered: boolean;
  activeLang: string = "en";
  viewEnMr: string = "View";
  cancelEnMr: string = "Cancel";
  editEnMr: string = "Edit";
  progressSpinnerDialog: any = null;
  downloadedBatches: string[] = [];
  pageMode: string;
  uploadedFile: string | ArrayBuffer;
  fileType: string;
  uploadedFileType: string;

  
  constructor(private route: ActivatedRoute, private viewApplicationService: ViewApplicationService, 
    private modalCtrl: ModalController, private auditTrailService: AuditTrailService, 
    private router: Router, public actionSheetController: ActionSheetController,
    private dialog: MatDialog, private domSanitizer: DomSanitizer ,private _snackBar: MatSnackBar) { }

  ngOnInit(): void { 
    this.route.params.subscribe((params: Params) => {
      this.applicationId = +params["applicationId"];
      this.pageMode = params["pageMode"];
      this.isLoading = true;
      this.viewApplicationService.fetchDetailView(this.applicationId)
      .subscribe(async (data: any)=>{
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.data = data;
          console.log("All Data >>>>>>>>>>>>>>>>>>>>>>>>",this.data);
          this.getDocuments(data?.panNumber);
        }
        else {
          this.viewApplicationService.errorToast(data.errorMessage);
        }
      }, error => {
        this.isLoading = false;
        this.viewApplicationService.errorToast(error?.error?.errorMessage||error?.error?.message);
      });
    });
  }

  editRecord(document: any) {
    localStorage.setItem("isEdit", "true");
    localStorage.setItem("pkQsid", document.pkQsid);
    this.router.navigate(["/question-answer"]);
  }

  showIntimationLetter() {
    this.isLoading = true;
    this.viewApplicationService
    .fetchLOI(this.data?.registrationId, this.data?.applicationNo)
    .subscribe(async ({status, data, errorMessage}) => {
      this.isLoading = false;
      if(status === 'SUCCESS') {
        const modal = await this.modalCtrl.create({
          component: ViewPdfComponent,
          componentProps: {
            base64: data,
            documentName: "Intimation Letter",
            fileName: "INTIMATION_LETTER_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
          }
        });
        modal.present();
      }
      else {
        this.viewApplicationService.errorToast(errorMessage);
      }
    }, error => {
      this.isLoading = false;
      this.viewApplicationService.errorToast("Unable to fetch LOI");
    });
  }

  showeAcceptanceletter() {
    this.isLoading = true;
    this.viewApplicationService
    .fetchAcceptance(this.data?.registrationId, this.data?.applicationNo)
    .subscribe(async ({status, data, errorMessage}) => {
      this.isLoading = false;
      if(status === 'SUCCESS') {
        const modal = await this.modalCtrl.create({
          component: ViewPdfComponent,
          componentProps: {
            base64: data,
            documentName: "Acceptance Letter",
            fileName: "ACCEPTANCE_LETTER_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
          }
        });
        modal.present();
      }
      else {
        this.viewApplicationService.errorToast(errorMessage);
      }
    }, error => {
      console.log(error);
      this.isLoading = false;
      this.viewApplicationService.errorToast("Unable to fetch Acceptance Letter");
    });
  }

  showeSurrenderLetter() {
    this.isLoading = true;
    this.viewApplicationService
    .fetchSurrender(this.data?.registrationId, this.data?.applicationNo)
    .subscribe(async ({status, data, errorMessage}) => {
      this.isLoading = false;
      if(status === 'SUCCESS') {
        const modal = await this.modalCtrl.create({
          component: ViewPdfComponent,
          componentProps: {
            base64: data,
            documentName: "Surrender Letter",
            fileName: "SURRENDER_LETTER_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
          }
        });
        modal.present();
      }
      else {
        this.viewApplicationService.errorToast(errorMessage);
      }
    }, error => {
      this.isLoading = false;
      this.viewApplicationService.errorToast("Unable to fetch Surrender Letter");
    });
  }



  showPol() {
    this.isLoading = true;
    this.viewApplicationService
    .fetchPOL(this.data?.registrationId, this.data?.applicationId)
    .subscribe(async ({status, data, errorMessage}) => {
      this.isLoading = false;
      if(status === 'SUCCESS') {
        const modal = await this.modalCtrl.create({
          component: ViewPdfComponent,
          componentProps: {
            base64: data,
            documentName: "Provisional Offer Letter (POL)",
            fileName: "PROVISIONAL_OFFER_LETTER_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
          }
        });
        modal.present();
      }
      else {
        this.viewApplicationService.errorToast(errorMessage);
      }
    }, error => {
      this.isLoading = false;
      this.viewApplicationService.errorToast("Unable to fetch POL");
    });
  }

//showNoc
showNoc() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchNOC(this.data?.registrationId, this.data?.applicationNo)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "NOC",
          fileName: "NOC_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch NOC");
  });
}

//showAllotment
showAllotment() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchAllotmentLetter(this.data?.registrationId, this.data?.applicationNo)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "Allotment Letter",
          fileName: "ALLOTMENT_LETTER_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch Allotment");
  });
}

//showAllotment
showPossession() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchPossessionLetter(this.data?.registrationId, this.data?.applicationNo)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "Possession Letter",
          fileName: "POSSESSION_LETTER_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch Possession");
  });
}

//Show Un Signed Agreement
showUnSignedAgreement() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchAgreementUnSignedCopy(this.data?.registrationId, this.data?.applicationNo)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "Agreement Copy",
          fileName: "AGREEMENTCOPY_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch Agreement Letter");
  });
}

//Show Agreement
showAgreement() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchAgreementCopy(this.data?.registrationId, this.data?.applicationNo)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "Agreement Copy",
          fileName: "AGREEMENTCOPY_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch Agreement Letter");
  });
}

showIndex2() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchIndex2(this.data?.registrationId, this.data?.applicationNo)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "Index 2 Copy",
          fileName: "INDEX2COPY_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch Index 2 Letter");
  });
}

//showIneligible
showeIneligible() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchIneligibleLetter(this.data?.registrationId, this.data?.applicationNo)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "Ineligible Letter",
          fileName: "INELIGIBLE_LETTER"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch Ineligible Letter");
  });
}


showeSign() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchESign(this.data?.registrationId, this.data?.applicationId)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "E-Sign",
          fileName: "eSign"+this.data?.registrationId+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch E-Sign");
  });
}

showApplicationsESign() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchApplicationsESign(this.data?.registrationId, this.data?.applicationId)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: " Application E-Sign",
          fileName: "Application_eSign"+this.data?.registrationId+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch E-Sign");
  });
}




  showAcknowledgement() {
    this.isLoading = true;
    this.viewApplicationService
    .fetchAcknowledgement(this.data?.registrationId, this.data?.applicationId)
    .subscribe(async ({status, data, errorMessage}) => {
      this.isLoading = false;
      if(status === 'SUCCESS') {
        const modal = await this.modalCtrl.create({
          component: ViewPdfComponent,
          componentProps: {
            base64: data,
            documentName: "Acknowledgement",
            fileName: "ACKNOWLEDGEMENT_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
          }
        });
        modal.present();
      }
      else {
        this.viewApplicationService.errorToast(errorMessage);
      }
    }, error => {
      this.isLoading = false;
      this.viewApplicationService.errorToast("Unable to fetch Acknowledgement");
    });
  }




  showEmdReceipt() {
    this.isLoading = true;
    this.viewApplicationService
    .fetchEmdReceipt(this.data?.registrationId, this.data?.applicationId)
    .subscribe(async ({status, data, errorMessage}) => {
      this.isLoading = false;
      if(status === 'SUCCESS') {
        const modal = await this.modalCtrl.create({
          component: ViewPdfComponent,
          componentProps: {
            base64: data,
            documentName: "EMD Receipt",
            fileName: "EMD_RECEIPT_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
          }
        });
        modal.present();
      }
      else {
        this.viewApplicationService.errorToast(errorMessage);
      }
    }, error => {
      this.isLoading = false;
      this.viewApplicationService.errorToast("Unable to fetch EMD Receipt");
    });
  }



  showCastValidity() {
    this.isLoading = true;
    this.viewApplicationService
    .fetchCastValidity(this.data?.registrationId, this.data?.applicationId)
    .subscribe(async ({status, data, errorMessage}) => {
      this.isLoading = false;
      if(status === 'SUCCESS') {
        const modal = await this.modalCtrl.create({
          component: ViewPdfComponent,
          componentProps: {
            base64: data,
            documentName: "Cast Validity",
            fileName: "CASTvALIDITY_LETTER_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
          }
        });
        modal.present();
      }
      else {
        this.viewApplicationService.errorToast(errorMessage);
      }
    }, error => {
      this.isLoading = false;
      this.viewApplicationService.errorToast("Unable to fetch Cast Validity");
    });
  }

  showCaseData() {
    this.isLoading = true;
    this.viewApplicationService
    .fetchCaseDatas(this.data?.registrationId, this.data?.applicationId)
    .subscribe(async ({status, data, errorMessage}) => {
      this.isLoading = false;
      if(status === 'SUCCESS') {
        const modal = await this.modalCtrl.create({
          component: ViewPdfComponent,
          componentProps: {
            base64: data,
            documentName: "All Letter",
            fileName: "ALL_LETTERS"+this.data?.registrationId+"_"+new Date().getTime()+".pdf"
          }
        });
        modal.present();
      }
      else {
        this.viewApplicationService.errorToast(errorMessage);
      }
    }, error => {
      this.isLoading = false;
      this.viewApplicationService.errorToast("Unable to fetch E-Sign");
    });
  }

  
  

  async getDocuments(panNumber: string) {
    this.manualRejectedQuestions = [];
    this.documents = [];
    this.verifiedStatus = [];
    this.isLoading = true;
    await this.auditTrailService.getProfileDetails(panNumber).subscribe((response: any) => {
      // const response: any = await profile;
      this.isLoading = false;
      if (response != null && !response.error) {
        if (response.length > 0) {
          this.profileDetails = response.pop();
          // this.mobileNo = this.profileDetails[0]["mobileNo"];
          // this.address = this.profileDetails[0]["address"];
          // this.currentAddress = this.profileDetails[0]["currentAddress"];
          // this.aliasName = this.profileDetails[0]["alisName"];
          // this.photo = this.domSanitizer.bypassSecurityTrustResourceUrl(
          //   "data:image/jpg;base64," + this.profileDetails[0]["photo"]
          // );
          // this.panNo = this.profileDetails[0]["panNo"];
          // this.name = this.profileDetails[0]["name"];
          // this.dob = this.profileDetails[0]["dob"];
          if (response.length > 0) {
            localStorage.setItem("editRecords", JSON.stringify(response));
            let employeeFlag = false;
            // response.sort((a, b) => a.pkQsid - b.pkQsid);
            // console.log(response);
            for (let i = 0; i < response.length; i++) {
              if (response[i]["qsCode"] == "Q_PAN" && response[i]["qs_ans_status"] == "Rejected-Duplicate") {
                response[i]["qs_ans_status"] = "MHADA Winner with Possession";
              }
              if (response[i]["qsCode"] == "Q_CASTE" && response[i]["qs_ans"] == "OPEN") {
                response[i + 1]["qs_ans_status"] = "Not Applicable";
              }
              if (response[i]["qsCode"] == "Q_DOMICILE" && response[i]["qs_ans_status"] == "Not-Verified") {
                response[i]["qs_ans_status"] = "Verification in Progress";
              }
              if (response[i]["qsCode"] == "Q_ITR" && response[i]["qs_ans_status"] == "Not-Verified") {
                response[i]["qs_ans_status"] = "Verification in Progress";
              } else if (response[i]["qsCode"] == "Q_ITR_SPOUSE" && response[i]["qs_ans_status"] == "Not-Verified") {
                response[i]["qs_ans_status"] = "Verification in Progress";
              }
              if (response[i]["qsCode"] == "Q_MARITAL" && response[i]["qs_ans"] != "Married") {
                // i = 6
                if (response[i + 3]["qsCode"] == "Q_WORK_STATUS" && response[i + 3]["qs_ans"] == "None") {
                  response[i + 1]["qs_ans_status"] = "Not Applicable"; // i = 7
                  response[i + 2]["qs_ans_status"] = "Not Applicable"; // i = 8
                  response[i + 4]["qs_ans_status"] = "Not Applicable"; // i = 8
                  response[i + 5]["qs_ans_status"] = "Not Applicable"; // i = 11
                  response[i + 6]["qs_ans_status"] = "Not Applicable"; // i = 12
                } else {
                  response[i + 1]["qs_ans_status"] = "Not Applicable"; // i = 7
                  response[i + 2]["qs_ans_status"] = "Not Applicable"; // i = 8
                  response[i + 5]["qs_ans_status"] = "Not Applicable"; // i = 11
                  response[i + 6]["qs_ans_status"] = "Not Applicable"; // i = 12
                }
              } else if (response[i]["qsCode"] == "Q_MARITAL" && response[i]["qs_ans"] == "Married") {
                // i= 6
                if (
                  response[i + 3]["qsCode"] == "Q_WORK_STATUS" &&
                  response[i + 3]["qs_ans_status"] != "Not Answered"
                ) {
                  // i = 9
                  if (response[i + 3]["qs_ans"] == "Both") {
                    if (
                      response[i + 4]["qs_ans_status"] == "Verified" ||
                      response[i + 4]["qs_ans_status"] == "Rejected" ||
                      response[i + 5]["qs_ans_status"] == "Verified" ||
                      response[i + 5]["qs_ans_status"] == "Rejected"
                    ) {
                      response[i + 6]["qs_ans_status"] = "Not Applicable";
                    } else if (
                      response[i + 6]["qs_ans_status"] == "Verified" ||
                      response[i + 6]["qs_ans_status"] == "Rejected" ||
                      response[i + 6]["qs_ans_status"] == "Not-Verified"
                    ) {
                      response[i + 4]["qs_ans_status"] = "Not Applicable";
                      response[i + 5]["qs_ans_status"] = "Not Applicable";
                    }
                  } else if (response[i + 3]["qs_ans"] == "Self") {
                    // i = 9
                    response[i + 5]["qs_ans_status"] = "Not Applicable"; // i= 11
                    response[i + 6]["qs_ans_status"] = "Not Applicable"; // i = 12
                  } else if (response[i + 3]["qs_ans"] == "Spouse") {
                    // i = 9
                    response[i + 6]["qs_ans_status"] = "Not Applicable";
                    response[i + 4]["qs_ans_status"] = "Not Applicable";
                  } else if (response[i + 3]["qs_ans"] == "None") {
                    response[i + 5]["qs_ans_status"] = "Not Applicable";
                    response[i + 6]["qs_ans_status"] = "Not Applicable";
                    response[i + 4]["qs_ans_status"] = "Not Applicable"; // i = 10
                  }
                }
              }
              if (employeeFlag == false) {
                if (response[i + 2] != undefined) {
                  if (
                    response[i]["qsCode"] == "Q_CENTRAL" &&
                    (response[i]["qs_ans_status"] == "Uploaded" ||
                      response[i]["qs_ans_status"] == "Not-Verified" ||
                      response[i]["qs_ans_status"] == "Verified")
                  ) {
                    response[i + 1]["qs_ans_status"] = "Not Applicable";
                    response[i + 2]["qs_ans_status"] = "Not Applicable";
                    response[6]["qs_ans_status"] = "Not Applicable";
                    employeeFlag = true;
                  } else if (
                    response[i + 1]["qsCode"] == "Q_STATE" &&
                    (response[i + 1]["qs_ans_status"] == "Uploaded" ||
                      response[i + 1]["qs_ans_status"] == "Not-Verified" ||
                      response[i + 1]["qs_ans_status"] == "Verified")
                  ) {
                    response[i]["qs_ans_status"] = "Not Applicable";
                    response[i + 2]["qs_ans_status"] = "Not Applicable";
                    employeeFlag = true;
                  } else if (
                    response[i + 2]["qsCode"] == "Q_MHADA" &&
                    (response[i + 2]["qs_ans_status"] == "Verified" || response[i + 2]["qs_ans_status"] == "Rejected")
                  ) {
                    response[i]["qs_ans_status"] = "Not Applicable";
                    response[i + 1]["qs_ans_status"] = "Not Applicable";
                    employeeFlag = true;
                  }
                }
              }
              if (
                (response[i]["qs_ans"] == "No" && response[i]["qs_ans_status"] == "Answered") ||
                (response[i]["qs_ans"] == "None" && response[i]["qs_ans_status"] == "Answered") ||
                (response[i]["qs_ans"] == "None of the above" && response[i]["qs_ans_status"] == "Answered")
              ) {
                if (response[i]["qsCode"] == "Q_CAST_VALID") {
                  response[i]["qs_ans_status"] = "Allowed with Condition";
                } else {
                  response[i]["qs_ans_status"] = "Not Applicable";
                  response[i]["qs_ans"] = "";
                }
              } else if (response[i]["qs_ans_status"] == "Not-Verified") {
                // response[i]["qs_ans_status"] = "Pending for Moderator Check";
                response[i]["qs_ans_status"] = "Verification in Progress";
                // response[i]["qs_ans"] = "";
              }
              // if (response[i]["qs_ans_status"] == "Verified" || response[i]["qs_ans_status"] == "N A") {
              //   this.verifiedStatus.push(response);
              // }
              if (response[i]["qs_ans"] != null) {
                if (response[i]["qs_ans"].includes("###")) {
                  if (response[i]["qsCode"] == "Q_ADDRESS") {
                    let splitData = response[i]["qs_ans"].split("###");
                    response[i]["qs_ans"] = splitData[0];
                    if (splitData[1] == "51") {
                      this.documentName = "No / Electricity Bill - MSEB";
                    } else if (splitData[1] == "52") {
                      this.documentName = "No / Electricity Bill - BEST";
                    } else if (splitData[1] == "53") {
                      this.documentName = "No / Electricity Bill - TORRENT";
                    } else if (splitData[1] == "53") {
                      this.documentName = "No / Electricity Bill - TORRENT";
                    } else if (splitData[1] == "54") {
                      this.documentName = "No / Electricity Bill - ADANI";
                    } else if (splitData[1] == "55") {
                      this.documentName = "No / Driving License";
                    } else if (splitData[1] == "56") {
                      this.documentName = "No / Gas Bill";
                    } else if (splitData[1] == "57") {
                      this.documentName = "No / Rent Agreement (Index-2)";
                    } else if (splitData[1] == "1") {
                      this.documentName = "Yes / Same as Aadhar";
                    } else {
                      this.documentName = splitData[1];
                    }
                  } else {
                    response[i]["qs_ans"] = response[i]["qs_ans"].split("###")[0];
                  }
                }
              }
              if (response[i]["qsCode"] != "Q_CONSENT") {
                this.documents.push(response[i]);
              }
            }
            for (let i = 0; i < this.documents.length; i++) {
              // if (this.documents[i]["qs_ans_status"] == "Rejected-Manual") {
              if (this.documents[i]["qs_ans_status"] != null) {
                if (this.documents[i]["qs_ans_status"].toLowerCase().includes("rejected") == true) {
                  this.manualRejectedQuestions.push(this.documents[i]);
                  // this.applyNowBtnDisabled = true;
                  // this.downloadEsignDisabled = true;
                  // this.isEsignDisabled = true;
                  this.areQuestionsNotAnswered = true;
                } else if (
                  this.documents[i]["qs_ans_status"].startsWith("Rejected") ||
                  this.documents[i]["qs_ans_status"] == "Not Answered" ||
                  this.documents[i]["qs_ans_status"] == "Pending for Moderator Check" ||
                  this.documents[i]["qs_ans_status"] == "Verification in Progress" ||
                  this.documents[i]["qs_ans_status"] == "MHADA Winner with Possession"
                ) {
                  // this.applyNowBtnDisabled = true;
                  // this.downloadEsignDisabled = true;
                  // this.isEsignDisabled = true;
                  this.areQuestionsNotAnswered = true;
                }
              } else {
                // this.applyNowBtnDisabled = true;
                // this.downloadEsignDisabled = true;
                // this.isEsignDisabled = true;
                this.areQuestionsNotAnswered = true;
              }
            }
            if (this.manualRejectedQuestions.length > 0) {
              // this.casteValidityRejected(this.manualRejectedQuestions);
            }
            setTimeout(() => {
              if (this.profileDetails[0]["affidavitStatus"] == "" && this.areQuestionsNotAnswered == false) {
                // this.applyNowBtnDisabled = true;
                // this.downloadEsignDisabled = true;
                // this.isEsignDisabled = false;
                localStorage.removeItem("eSign");
              } else if (
                this.profileDetails[0]["affidavitStatus"].toLowerCase() == "pending" &&
                this.areQuestionsNotAnswered == false
              ) {
                // localStorage.setItem("eSign", "true");
                if (localStorage.getItem("eSign") == "true") {
                  // this.getSignedPdf();
                } else {
                  localStorage.removeItem("eSign");
                  // this.applyNowBtnDisabled = true;
                  // this.downloadEsignDisabled = true;
                  // this.isEsignDisabled = false;
                }
              } else if (
                this.profileDetails[0]["affidavitStatus"].toLowerCase() == "verified" &&
                this.areQuestionsNotAnswered == false
              ) {
                // this.applyNowBtnDisabled = false;
                // this.downloadEsignDisabled = false;
                // this.isEsignDisabled = true;
              }
            }, 1000);
          } else {
            // this.warningToast();
          }
        } else {
          // this.applyNowBtnDisabled = true;
          // this.downloadEsignDisabled = true;
          // this.isEsignDisabled = true;
          this.areQuestionsNotAnswered = true;
          this.documents = [];
        }
      } else {
        // this.errorToast();
      }
    });
  }

  showStatusClass(status: string) {
    let statusClass = 'text-white p-1 pl-2 pr-2 text-sm border-round';
    if(status === 'Verified' || status === 'Answered') {
      return statusClass + ' bg-green-400';
    }
    else if(status === 'Not Applicable') {
      return statusClass + ' surface-700';
    }
    else if(status?.indexOf('Pending') >= 0) {
      return statusClass + ' bg-orange-400';
    }
    else {
      return statusClass + ' bg-orange-400';
    }
  }

  async presentActionSheet(document: any) {
    let canCasteValidityBeEdited = false;
    if (document.qsCode == "Q_CAST_VALID") {
      if (this.documents[15]["qsCode"] == "Q_CASTE" && this.documents[15]["qs_ans"] != "OPEN") {
        canCasteValidityBeEdited = true;
      }
    }
    let actionSheetOptions: any[] = [];
    if (
      document.pkQsid == "4" ||
      document.pkQsid == "6" ||
      document.pkQsid == "9" ||
      document.pkQsid == "12" ||
      document.pkQsid == "14" ||
      document.pkQsid == "17" ||
      document.pkQsid == "18" ||
      document.pkQsid == "19" ||
      document.pkQsid == "20" ||
      document.pkQsid == "21" ||
      document.pkQsid == "22" ||
      document.pkQsid == "23" ||
      document.pkQsid == "25" ||
      document.pkQsid == "26" ||
      document.pkQsid == "31" ||
      canCasteValidityBeEdited ||
      (document.qs_ans_status != "Not Applicable" &&
        (document.pkQsid == "10" ||
          document.pkQsid == "11" ||
          document.pkQsid == "28" ||
          document.pkQsid == "29" ||
          document.pkQsid == "30"))
    ) {
      actionSheetOptions = [
        {
          cssClass: "first-button",
          text: this.viewEnMr,
          icon: "eye",
          data: 10,
          handler: () => {
            this.viewDocument(document);
          },
        },
        {
          text: this.editEnMr,
          icon: "create",
          data: "Data value",
          handler: () => {
            this.editRecord(document);
          },
        },
        {
          cssClass: "last-button",
          text: this.cancelEnMr,
          icon: "close",
          role: "cancel",
          handler: () => {
            // console.log('Cancel clicked');
          },
        },
      ];
    } else {
      actionSheetOptions = [
        {
          cssClass: "first-button",
          text: this.viewEnMr,
          icon: "eye",
          data: 10,
          handler: () => {
            this.viewDocument(document);
          },
        },
        // {
        //   text: this.editEnMr,
        //   icon: "create",
        //   data: "Data value",
        //   handler: () => {
        //     this.editRecord(document);
        //   },
        // },
        {
          cssClass: "last-button",
          text: this.cancelEnMr,
          icon: "close",
          role: "cancel",
          handler: () => {
            // console.log('Cancel clicked');
          },
        },
      ];
    }
    let status = document.qs_ans_status != null ? document.qs_ans_status : "-";
    const actionSheet = await this.actionSheetController.create({
      header: document.qsProfileDescription[this.activeLang] + " - ( " + status + " )",
      cssClass: "my-custom-class",
      buttons: actionSheetOptions,
    });
    await actionSheet.present();

    const { role, data } = await actionSheet.onDidDismiss();
    // console.log('onDidDismiss resolved with role and data', role, data);
  }

  async viewDocument(document) {
    console.log(document);

    if (document.qs_doc_document != "" && document.qs_doc_document != null && document.qs_doc_document != "-") {
      const progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
        disableClose: true,
        panelClass: "progressSpinner",
      });
      let imageBackUrl = null;
      let image = document.qs_doc_document.split(",");
      console.log(image);

      if (image[1] != undefined) {
        await this.auditTrailService.downloadFileV1(image[1].split("/").pop(), this.data?.registrationId.toString()).subscribe((response: any) => {
          progressSpinnerDialog.close();
          if (response != null && !response.error) {
            // let file = new Blob([response], { type: "image/*" });
            // var fileURL = URL.createObjectURL(file);
            // imageBackUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
            var binary = "";
            var bytes = new Uint8Array(response);
            var len = bytes.byteLength;
            for (var i = 0; i < len; i++) {
              binary += String.fromCharCode(bytes[i]);
            }
            let url = window.btoa(binary);
            let fileURL = this.domSanitizer.bypassSecurityTrustUrl("data:image/jpg;base64," + url);

            // let imageUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
            imageBackUrl = fileURL;
            console.log(imageBackUrl);
          } else {
            progressSpinnerDialog.close();
            // this.errorToast();
          }
        });
      }
      await this.auditTrailService.downloadFileV1(image[0].split("/").pop(), this.data?.registrationId.toString()).subscribe((response: any) => {
        progressSpinnerDialog.close();
        console.log(response);

        if (response != null && !response.error) {
          let file = new Blob([response], { type: "image/*" });
          var fileURL = URL.createObjectURL(file);

          setTimeout(() => {
            var binary = "";
            var bytes = new Uint8Array(response);
            var len = bytes.byteLength;
            for (var i = 0; i < len; i++) {
              binary += String.fromCharCode(bytes[i]);
            }
            let url = window.btoa(binary);
            let fileURL = this.domSanitizer.bypassSecurityTrustUrl("data:image/jpg;base64," + url);

            // let imageUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
            let imageUrl = fileURL;
            console.log(fileURL);
            this.progressSpinnerDialog = this.dialog.open(ViewProfileDocumentComponent, {
              disableClose: false,
              width: "600px",
              data: [document.qsProfileDescription, document.qs_ans_status, imageUrl, imageBackUrl],
            });
          }, 100);
        } else {
          progressSpinnerDialog.close();
          // this.errorToast();
        }
      });
    } else {
      // this.warningToast();
    }
  }

  // for download All Letters 

  downloadLetters() {

    if(this.data?.applicationNo !==null ){
      console.log(this.data?.applicationNo);
      this.auditTrailService.downloadLetters(this.data?.applicationNo)
      .subscribe((data) => {
        this.isLoading = false;
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.downloadedBatches.push(this.data?.applicationNo);
          this.downloadFile(data.base64File, data.fileName);
          this.successToast();
        }
        else {
          this.viewApplicationService.errorToast(data.errorMessage);  
        }
      }, error => {
        this.isLoading = false;
        this.viewApplicationService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
        // this.exportImportService.errorToast("Please Enter Application Number:"+this.form.value.applicationNo);

      });
  
    } else {
      this.viewApplicationService.errorToast("Please Enter Application Number");  
    }

    
  }

//corrigendum letters download

downloadCorrigendumLetters() {

  if(this.data?.applicationNo !==null ){
    console.log(this.data?.applicationNo);
    this.auditTrailService.downloadCorrigendumLetter(this.data?.applicationNo)
    .subscribe((data:any) => {
      this.isLoading = false;
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        this.downloadedBatches.push(this.data?.applicationNo);
        this.downloadFile(data.base64File, data.fileName);
        this.successToast();
      }
      else {
        this.viewApplicationService.errorToast(data.errorMessage);  
      }
    }, error => {
      this.isLoading = false;
      this.viewApplicationService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
      // this.exportImportService.errorToast("Please Enter Application Number:"+this.form.value.applicationNo);

    });

  } else {
    this.viewApplicationService.errorToast("Please Enter Application Number");  
  }

  
}

async errorToast(errorMessage: string, dur?: number) {
  await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    }
  );
}

genereteAgreementLtr(){

  console.log('Button Call');
  console.log(this.data);
  console.log(this.data.applicationNo);
  this.isLoading = false;

  if(this.data.showPossession === 'Y'){
    this.viewApplicationService.generateAgreementLtr(this.data.applicationNo)
    .subscribe((data) => {
      console.log("Data get after letter generate", data);
      if(data.status === 'SUCCESS') {
        console.log("Agreement Letter Generated Successfully.");
        this.downloadFile(data.base64File, data.fileName);
        this.ngOnInit();
        this.isLoading = false;
      }
      else {
        this.errorToast(data.errorMessage);
        this.isLoading = false;
      }
    }, error => {
      this.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
      this.isLoading = false;
    });
  }else{
    this.viewApplicationService.errorToast("Applicant Possession Letter is not published");
    this.isLoading = false;
  }


  
}

async uploadSignedAgrmntLtr() {
  this.isLoading =false;
  this.fileType = "AGREEMENT_LETTER";
  const modal = await this.modalCtrl.create({
      component: UploadFileModalComponent,
      componentProps: {
          modalHeader: "Agreemnet Letter File Upload",
          base64: this.data.agreementLtrFile != null? this.data.agreementLtrFile:null,
          fileType: "Agreement Letter",
      }
  });
  modal.present();

  const { data } = await modal.onWillDismiss();
  
  if (data != null) {
      this.onSubmit(data, this.fileType);
  }
}

async uploadIndxLtr() {
  this.isLoading =false;
  this.fileType = "INDEX_2_LETTER";
  const modal = await this.modalCtrl.create({
      component: UploadFileModalComponent,
      componentProps: {
          modalHeader: "Index 2 Letter File Upload",
          base64: this.data.agreementLtrFile != null? this.data.agreementLtrFile:null,
          fileType: "Index Letter",
      }
  });
  modal.present();

  const { data } = await modal.onWillDismiss();
  
  if (data != null) {
      this.onSubmit(data, this.fileType);
  }
}

onSubmit(file: any, fileType: string){
  this.isLoading = false;
  this.submitDisabled = true;

  console.log("onSubmit in form >>>>> ",file);
  this.uploadedFile = file;
  this.uploadedFileType = fileType;
  if(this.uploadedFile){
    this.viewApplicationService.uploadAgrmntNIndxLtr(this.uploadedFile, 
      this.uploadedFileType, this.data.applicationNo)
    .subscribe((data) => {
      console.log("Status get after letter uploaded", data);
      if(data.errorMessage === null) {
        console.log("Letter Uploaded Successfully.");
        this.viewApplicationService.successToast("Letter Uploaded Successfully.");
        this.isLoading = false;
        this.ngOnInit();
      }
      else {
        this.errorToast(data.errorMessage);
        this.isLoading = false;
      }
    }, error => {
      this.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
      this.isLoading = false;
    });
  }else{
    this.viewApplicationService.errorToast("Please Upload the File.");
    this.isLoading = false;
  }
}

  downloadFile(base64:string | ArrayBuffer, fileName:string){
    const src = `${base64}`;
    const link = document.createElement("a")
    link.href = src
    link.download = fileName
    link.click()
    
    link.remove()
  }
  async successToast() {
    await this._snackBar.open(
        " Letters Successfully Downloaded",
        "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
        }
    );
}
}
